import { render, staticRenderFns } from "./page_403.vue?vue&type=template&id=358aba76&"
import script from "./page_403.vue?vue&type=script&lang=js&"
export * from "./page_403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports